import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function CodeCopyHandler() {
  const { pathname } = useLocation();

  useEffect(() => {
    const attachButtons = () => {
      const pres = document.querySelectorAll("#posts pre, #about pre");
      pres.forEach((pre) => {
        if (pre.querySelector(".code-copy-btn")) return;

        pre.style.position = "relative";

        const btn = document.createElement("button");
        btn.className = "code-copy-btn";
        btn.type = "button";
        btn.setAttribute("aria-label", "Copy code snippet");
        btn.title = "Copy code";
        btn.innerHTML = `<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg><span>Copy</span>`;

        btn.addEventListener("click", async (e) => {
          e.stopPropagation();
          const codeEl = pre.querySelector("code");
          const textToCopy = codeEl ? codeEl.innerText : pre.innerText;

          try {
            await navigator.clipboard.writeText(textToCopy);
            btn.classList.add("copied");
            btn.innerHTML = `<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg><span>Copied!</span>`;
            setTimeout(() => {
              btn.classList.remove("copied");
              btn.innerHTML = `<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg><span>Copy</span>`;
            }, 2000);
          } catch (err) {
            console.error("Failed to copy code: ", err);
          }
        });

        pre.appendChild(btn);
      });
    };

    const timer = setTimeout(attachButtons, 120);
    return () => clearTimeout(timer);
  }, [pathname]);

  return null;
}
